// src/pages/admin/taxSettingsPage.jsx
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TaxSettingsList from '../../components/adminComponents/taxSettings/TaxSettingsList';
import { 
  getTaxSettings, 
  saveTaxSettings, 
  updateDefaultTaxRate, 
  toggleTaxable, 
  updateTaxRate,
  applyDefaultRateToAll 
} from '../../actions/adminAction/taxSettingsActions';
import { notify } from '../../util/notifications';
import { getAccessLevelsByModule } from '../../util/customMethods.js';

const pageTitle = "Tax Settings";

class TaxSettingsPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: false
    };
    this.checkViewAccess = this.checkViewAccess.bind(this);
    this.loadTaxSettings = this.loadTaxSettings.bind(this);
    this.handleSaveTaxSettings = this.handleSaveTaxSettings.bind(this);
    this.handleUpdateDefaultRate = this.handleUpdateDefaultRate.bind(this);
    this.handleToggleTaxable = this.handleToggleTaxable.bind(this);
    this.handleUpdateTaxRate = this.handleUpdateTaxRate.bind(this);
    this.handleApplyToAll = this.handleApplyToAll.bind(this);
  }

  componentWillMount = () => {
    document.title = pageTitle;
    this.loadTaxSettings();
  }

  checkViewAccess = (_accessLevel = {}) => {
    // if (_accessLevel.basicAccess.view !== true) {
    //   this.props.history.push('/admin/notfound');
    // }
  }

  loadTaxSettings = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch(getTaxSettings()).finally(() => {
      this.setState({ loading: false });
    });
  }

  handleUpdateDefaultRate = (value) => {
    const { dispatch } = this.props;
    dispatch(updateDefaultTaxRate(value));
  }

  handleToggleTaxable = (chargeListId) => {
    const { dispatch } = this.props;
    dispatch(toggleTaxable(chargeListId));
  }

  handleUpdateTaxRate = (chargeListId, rate) => {
    const { dispatch } = this.props;
    dispatch(updateTaxRate(chargeListId, rate));
  }

  handleApplyToAll = () => {
    const { dispatch } = this.props;
    dispatch(applyDefaultRateToAll());
  }

  handleSaveTaxSettings = async () => {
    const { dispatch, taxSettings } = this.props;
    this.setState({ loading: true });

    const res = await dispatch(saveTaxSettings(taxSettings));
    this.setState({ loading: false });

    if (res.statusCode === 200) {
      notify.createNotification('success', res.statusMsg, this.props.refNotify);
    } else {
      notify.createNotification('error', res.statusMsg, this.props.refNotify);
    }
  }

  render() {
    const accessLevelObj = getAccessLevelsByModule('Tax Settings');
    this.checkViewAccess(accessLevelObj);

    return (
      <Fragment>
        <div className="page-header">
          <div className="row mb-10">
            <div className="col-md-12 col-sm-12">
              <div className="title">
                <h4><i className="fa fa-percent"></i> {pageTitle}</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="pd-10 bg-white border-radius-4 box-shadow container-box">
          {this.state.loading ? (
            <div className="text-center"><i className="fa fa-spinner fa-spin fa-2x"></i></div>
          ) : (
            <TaxSettingsList
              taxSettings={this.props.taxSettings}
              onUpdateDefaultRate={this.handleUpdateDefaultRate}
              onToggleTaxable={this.handleToggleTaxable}
              onUpdateTaxRate={this.handleUpdateTaxRate}
              onApplyToAll={this.handleApplyToAll}
              onSave={this.handleSaveTaxSettings}
              accessLevel={accessLevelObj || {}}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authInfo: state.authInfo,
  refNotify: state.refNotify,
  taxSettings: state.taxSettings
});

export default withRouter(connect(mapStateToProps)(TaxSettingsPage));